export enum BREAK_POINTS {
  XS = 0,
  SM = 600,
  MD = 900,
  LG = 1200,
  MLG = 1312, // breakpoint for in between LG nd XL
  XL = 1536,
  XXL = 1920,
}
